export const ALERT_STATUS_LIST = [
  {
    id: 'resolved',
    name: 'Resolved',
  },
  {
    id: 'firing',
    name: 'Firing',
  },
  {
    id: 'pending',
    name: 'Pending',
  },
  {
    id: 'validated',
    name: 'Validated',
  },
  {
    id: 'notified',
    name: 'Notified',
  },
  {
    id: 'invalidated',
    name: 'Invalidated',
  },
  {
    id: 'resolved_notified',
    name: 'Resolved Notified',
  },
];

export const ALERT_PRIORITY_LIST = [
  {
    id: 'URGENT',
    name: 'URGENT',
  },
  {
    id: 'HIGH',
    name: 'HIGH',
  },
  {
    id: 'MEDIUM',
    name: 'MEDIUM',
  },
  {
    id: 'LOW',
    name: 'LOW',
  },
];

export const ALERT_INFRA_LIST = [
  {
    id: 'All',
    name: 'All',
  },
  {
    id: 'v1',
    name: 'v1',
  },
  {
    id: 'v2',
    name: 'v2',
  },
];
